import { render } from "./ThAbout.vue?vue&type=template&id=6e260e7b&scoped=true"
const script = {}

import "./ThAbout.vue?vue&type=style&index=0&id=6e260e7b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e260e7b"

export default script